<article class="blog-card d-flex flex-column w-100 bg-white">
    <a [routerLink]="routerLinkValue" [attr.title]="titleText || 'Ir al articulo del blog'"
        [attr.aria-label]="titleText ? 'Leer ' + titleText : 'Leer articulo del blog'"
        class="blog-card__media">
        <picture class="blog-card__picture">
            <source *ngIf="imageUrl | toAvif as avif" [srcset]="avif" type="image/avif" />
            <img
                class="blog-card__img"
                width="640"
                height="360"
                [src]="imageUrl"
                [attr.srcset]="imageSrcset"
                sizes="(max-width: 992px) 92vw, 368px"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                [alt]="titleText || 'Blog card image'"
            />
        </picture>
        <span *ngIf="category" class="blog-card__category">{{ category }}</span>
    </a>

    <div class="blog-card__content h-100 d-flex flex-column justify-content-between text-start p-4">
        <div class="mb-2">
            <div *ngIf="hasMeta" class="blog-card__meta">
                <span *ngIf="formattedDate" class="blog-card__meta-item">{{ formattedDate }}</span>
                <span *ngIf="readingTime" class="blog-card__meta-item">
                    <span class="blog-card__meta-dot" aria-hidden="true">·</span>
                    {{ readingTime }} min read
                </span>
                <span *ngIf="author" class="blog-card__meta-item">
                    <span class="blog-card__meta-dot" aria-hidden="true">·</span>
                    By {{ author }}
                </span>
            </div>

            <a [routerLink]="routerLinkValue" class="text-decoration-none text-black"
                [attr.title]="titleText || 'Ir al articulo del blog'"
                [attr.aria-label]="titleText ? 'Leer ' + titleText : 'Leer articulo del blog'">
                <h3 class="content__title fw-bold mb-2">
                    {{ titleText }}
                </h3>
            </a>

            <p class="content__text" [innerHTML]="textText"></p>
        </div>

        <a [routerLink]="routerLinkValue" class="fw-bold text-black text-decoration-none blog-card__cta"
            [attr.title]="titleText ? 'Read article: ' + titleText : 'Read blog article'"
            [attr.aria-label]="titleText ? 'Read article: ' + titleText : 'Read blog article'">
            Continue reading
        </a>
    </div>
</article>
